module.exports = __webpack_public_path__ + "media/images/loghi/lba_logo_sc-18a779ee0e75c44e1eb40e3dea2e7c3c.png";